// CB:BEGIN ui-metric-card
import React from 'react';

interface MetricCardProps {
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  accent?: string;
  accentBg?: string;
  /** Optional sublabel beneath the metric value */
  sub?: string;
  /** Optional right-aligned badge */
  badge?: React.ReactNode;
  onClick?: () => void;
}

const MetricCard: React.FC<MetricCardProps> = ({
  value, label, icon, accent, accentBg, sub, badge, onClick,
}) => (
  <div
    onClick={onClick}
    style={{
      background: '#fff',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      padding: '20px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      cursor: onClick ? 'pointer' : undefined,
      transition: onClick ? 'box-shadow 0.12s' : undefined,
    }}
    onMouseEnter={onClick ? (e) => { (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; } : undefined}
    onMouseLeave={onClick ? (e) => { (e.currentTarget as HTMLDivElement).style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; } : undefined}
  >
    {icon && (
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 10,
          background: accentBg || '#f0faf9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: accent || '#123c3b',
        }}
      >
        {icon}
      </div>
    )}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ fontSize: 26, fontWeight: 800, color: accent || '#0f172a', lineHeight: 1 }}>
          {value}
        </div>
        {badge}
      </div>
      <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{label}</div>
      {sub && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{sub}</div>}
    </div>
  </div>
);

export default MetricCard;
// CB:END ui-metric-card
